import { referer } from '~/mixins/referer'

export const tracksearch = {

    mixins: [referer],

    methods: {

        trackSearchMatomo(searchPayload, customDimension = false) {

            const matomoConfig = this.$config.matomo

            const baseUrl = window.location.protocol +
                (window.location.protocol.slice(-1) === ':' ? '' : ':') +
                '//' +
                window.location.host +
                this.$router.options.base.replace(/\/+$/, '')

            const from = this.$router.referer

            const referrerUrl = from && from.fullPath
                ? baseUrl + this.getResolvedHref(from.fullPath)
                : undefined

            if (referrerUrl) {
                this.$matomo.setReferrerUrl(referrerUrl)
            }

            if(matomoConfig.onMetaChange || matomoConfig.onAfterNavigation) {
                this.$matomo.setDocumentTitle(document.title)
            } else {
                this.$matomo.setDocumentTitle(this.$route.path)
            }

            this.$matomo.setCustomUrl(baseUrl + this.$route.fullPath)

            if(customDimension) {
                this.$matomo.setCustomDimension(customDimension.id, customDimension.value)
            }

            /*const keyword = this.meta.track_keyword
            const category = this.meta.track_category
            const countResults = this.meta.total*/

            this.$matomo.trackSiteSearch(searchPayload.keyword, searchPayload.category, searchPayload.countResults)


            if(matomoConfig.enableLinkTracking !== false) {
                this.$matomo.enableLinkTracking()
            }

            if(matomoConfig.trackAllContentImpressions !== false) {
                this.$matomo.trackAllContentImpressions()
            }

            if(matomoConfig.trackVisibleContentImpressions !== false) {
                this.$matomo.trackVisibleContentImpressions()
            }

            if(matomoConfig.trackMedia !== false) {

                if (window.Matomo) {
                    window.Matomo.MediaAnalytics.scanForMedia()
                } else {
                    window.matomoMediaAnalyticsAsyncInit = function () {
                        Matomo.MediaAnalytics.scanForMedia()
                    }
                }

            }

        },

        getResolvedHref (path) {
            return this.$router.resolve(path).href
        },
    }

}
